import { z } from "zod"
import { defineOperationContext } from "../define"
import type { AllergenDetectInput } from "../schemas/allergen-detect"

/** Display-only, so it is bounded: the envelope outlives the Trigger run. */
const PRODUCT_NAME_MAX = 160

export const allergenDetectContextSchema = z.object({
	productId: z.string().uuid().optional(),
	productName: z.string().max(PRODUCT_NAME_MAX),
})

export type AllergenDetectContext = z.infer<typeof allergenDetectContextSchema>

export const allergenDetectContextSpec = defineOperationContext<
	AllergenDetectInput,
	AllergenDetectContext
>({
	version: 1,
	schema: allergenDetectContextSchema,
	fromInput: (input) => ({
		productId: input.productId,
		productName: input.name.slice(0, PRODUCT_NAME_MAX),
	}),
})
